import { type ReceiptSettings } from '@/models/receipt/ReceiptSettings';
import { HttpError, getJwt } from '../common';

const BASE_URL = import.meta.env.VITE_API_URL;

// Brand-level receipt settings, brand-scoped (PortalAPI guards brand ownership).
export const receiptSettingsApi = {
    get: async (brandId: string): Promise<ReceiptSettings> => {
        const response = await fetch(`${BASE_URL}/receipts/settings?brandId=${brandId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${getJwt()}`
            }
        });
        if (!response.ok) throw new HttpError(response.status, await response.text().catch(() => ''));
        return await response.json();
    },
    save: async (brandId: string, settings: ReceiptSettings): Promise<void> => {
        const response = await fetch(`${BASE_URL}/receipts/settings?brandId=${brandId}`, {
            method: 'PUT',
            body: JSON.stringify(settings),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getJwt()}`
            }
        });
        if (!response.ok) throw new HttpError(response.status, await response.text().catch(() => ''));
    }
};
